import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { ForgottenPasswordDto } from '../../models/userAccounts/userAccount.models'

@Component({
    selector: 'account-forgottenPassword',
    template: require('./forgottenPassword.component.html'),
    styles: [require('./login.component.css')]
})

export class ForgottenPasswordComponent {
    request: ForgottenPasswordDto;
    loading = false;

    constructor(private router: Router, private authenticationService: AuthService) {
        this.request = new ForgottenPasswordDto;
    }

    onSubmit() {
        this.loading = true;
        this.authenticationService.forgotPassword(this.request)
            .subscribe(() => this.router.navigateByUrl('/account/login'), () => { this.loading = false; });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/userAccounts/forgottenPassword.component.ts